
import { getProNameList, exportExl } from "@/api/project";
import { getDevInfoByProId, getDevAttrName } from "@/api/device";
import { getProByDeviceIdent, getPhoneByProject, getPoliceHisList, getPoliceProcess, getBjHisExport } from "@/api/warning";
import moment from 'moment';

import XLSX from 'xlsx'
import FileSaver from 'file-saver'
export default {
    name: "alarmHistory",
    data() {

        return {
            pickerOptions: {//日期选择，快捷选项
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6
				},
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
            selectVal: {
                allProject: '',
                deviceId: '',
                // attrIdent: '',
                alarmDate: [moment().subtract(7, "days").format('x'), moment().format('x')],
            },

            tableData: [],
            tableColumn: [
                {
                    id: '1',
                    prop: 'createTime',
                    label: '报警时间'
                }, {
                    id: '2',
                    prop: 'eventName',
                    label: '报警名称'
                }, {
                    id: '3',
                    prop: 'deviceName',
                    label: '报警设备'
                }, {
                    id: '5',
                    prop: 'triggers',
                    label: '触发条件'
                }, {
                    id: '6',
                    prop: 'eventLevelName',
                    label: '报警等级'
                }, {
                    id: '4',
                    prop: 'proName',
                    label: '所属项目'
                }, {
                    //     id: '7',
                    //     prop: 'rulesState',
                    //     label: '报警状态'
                    // }, {
                    id: '8',
                    prop: 'process',
                    label: '处理状态',
                    xqliType: true
                }, {
                    id: '9',
                    prop: 'handle',
                    label: '操作',
                    xqliHandle: true
                },
            ],
            total: 0,
            pageSize: 20,
            page: 1,
            currentPage:1,

            drawer: false,//详情抽屉
            direction: 'rtl',

            details: [
                {
                    id: 'eventName',
                    key: '报警名称',
                    val: ''
                }, {
                    id: 'deviceName',
                    key: '报警设备',
                    val: ''
                }, {
                    id: 'sn',
                    key: 'SN序列号',
                    val: ''
                }, {
                    id: 'dpName',
                    key: '报警点位',
                    val: ''
                }, {
                    id: 'trigAttrValue',
                    key: '报警值',
                    val: ''
                }, {
                    id: 'triggers',
                    key: '触发条件',
                    val: ''
                }, {
                    id: 'eventLevelName',
                    key: '报警等级',
                    val: ''
                }, {
                    id: 'device_type_name',
                    key: '设备类型',
                    val: ''
                }, {
                    id: 'proName',
                    key: '所属项目',
                    val: ''
                }, {
                    id: 'customerName',
                    key: '所属客户',
                    val: ''
                }, {
                    id: 'createTime',
                    key: '报警开始时间',
                    val: ''
                }, {
                    id: '',
                    key: '报警结束时间',
                    val: ''
                }, {
                    id: '',
                    key: '报警持续时长',
                    val: ''
                }, {
                    id: 'sms',
                    key: '通知联系人',
                    val: ''
                }, {
                    id: 'inform',
                    key: '通知方式',
                    val: '短信'
                }, {
                    id: 'processing',
                    key: '是否处理',
                    val: ''
                }, {
                    id: 'processingType',
                    key: '处理类型',
                    val: ''
                }, {
                    id: 'processDesc',
                    key: '处理说明',
                    val: ''
                },
            ],

            pupUp: false,
            eventHistoryIdent: '',
            ruleForm: {
                alarmRadio: 1,
                textarea: '',
            },
            rules: {
                textarea: [{ required: true, message: '请输入处理方法，200字以内', trigger: 'blur' }]
            },

            proNameList: [],
            deviceList: [],
            attrNameList: [],

            timer: null,

            multipleSelection: [],
            proIds: [],

        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        if (this.$route.query.data) {
            this.selectVal.allProject = this.$route.query.data.customer_id
            this.getDevInfoByProId()
        }
        this.getProNameList()
        this.getPoliceHisList()//历史数据

        this.timer = setInterval(() => {
            // this.getPoliceHisList()
        }, 10000)
    },
    mounted() {

    },

    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {

        async getProNameList() {
            const res = await getProNameList()
            if (res.code == 200) {
                this.proNameList = res.data
            }
        },

        async getPoliceHisList() {
            let params = {
                page: this.page,
                offset: this.pageSize,
                sortBy: '',
                order: '',
                isRead: '',
                projectId: this.selectVal.allProject, //项目id
                deviceIdent: this.selectVal.deviceId ? [this.selectVal.deviceId] : [], //设备标识

                startTime: this.selectVal.alarmDate[0].toString().slice(0, 10), //开始时间
                endTime: moment(this.selectVal.alarmDate[1], 'x').add(1, "days").format('x').toString().slice(0, 10), //结束时间
            }
            const res = await getPoliceHisList(params)
            let idList = []
            let data = []
            if (res.code == 200) {
                this.total = res.data.total
                this.currentPage = res.data.page
                data = res.data.rows
                data.forEach(el => {
                    let eventLevelName = ''
                    switch (el.eventLevel) {
                        case 1:
                            eventLevelName = '低级'
                            break;
                        case 2:
                            eventLevelName = '中级'
                            break;
                        case 3:
                            eventLevelName = '高级'
                            break;

                        default:
                            eventLevelName = '-'
                    }
                    this.$set(el, 'eventLevelName', eventLevelName)

                    let trigAttr = el.trigAttr ? JSON.parse(el.trigAttr) : []
                    let trigAttrName = el.trigAttrName ? JSON.parse(el.trigAttrName) : []
                    let trigCondition = el.trigCondition ? JSON.parse(el.trigCondition) : []
                    let indexArr = this.findall(trigCondition || [], '%s')

                    el.dpName = trigAttrName[0] ? trigAttrName[0] : ''
                    el.dpId = trigAttr[0] ? trigAttr[0] : ''
                    el.sign = trigCondition[1] ? trigCondition[1] : ''
                    el.val = trigCondition[2] ? trigCondition[2] : ''
                    for (let i = 0; i < indexArr.length; i++) {
                        trigCondition.splice(indexArr[i], 1, trigAttrName[i])
                    }
                    el.triggers = trigCondition.join('')

                    if (el.process === 0) {
                        el.rulesState = '报警中'
                    } else {
                        if (el.deviceStatus === 3) {
                            el.rulesState = '报警中'
                        } else {
                            el.rulesState = '恢复正常'
                        }
                    }
                    idList.push(el.deviceIdent)
                })
                idList = [...new Set(idList)]
            }

            // 通过设备标识查询所属项目
            const res1 = await getProByDeviceIdent(idList)
            if(res1.code==200){
                data.map(item => {
                    res1.data.map(el => {
                        if (item.deviceIdent === el.deviceIdent) {
                            this.$set(item, 'proId', el.id)
                            this.$set(item, 'proName', el.proName)
                            this.$set(item, 'customerName', el.customerName)
                        }
                    })
                })
            }
            this.tableData = data
        },

        async handleDetails(row) {
            this.getPhoneByProject(row.proId)
            this.getDevInfo(row.proId, row.deviceIdent)
            this.eventHistoryIdent = row.eventHistoryIdent
            let processingType = ''
            if (row.process == 1) {
                processingType = '报警'
            } else if (row.process == 2) {
                processingType = '误报'
            } else {
                processingType = ''
            }
            this.details.forEach(el => {
                el.val = row[el.id] ? row[el.id] : ''
                if (el.id === 'processing') {
                    el.val = row.process == 0 ? '未处理' : '已处理'
                }
                if (el.id === 'processingType') {
                    el.val = processingType
                }
                if (el.id === 'inform') {
                    el.val = '短信'
                }
                // if (el.id === 'trigAttrValue') {
                //     el.val = row.trigAttrValue
                //     // this.$set(el, 'val', row.trigAttrValue ? JSON.parse(row.trigAttrValue)[0] : '')
                //     // el.trigAttrValue = row.trigAttrValue?JSON.parse(row.trigAttrValue)[0] : ''
                //     // el.trigAttrValue = JSON.parse(row.trigAttrValue)[0]  || ''
                //     // el.val = '短信'
                // }
            })
            this.drawer = true
        },

        async getPhoneByProject(id) {
            let params = {
                projectIds: [id]
            }
            const res = await getPhoneByProject(params)
            if (res.code === 200) {
                let name = ''
                if (!res.data[0].contacts_phone && !res.data[0].organize_phone) {
                    name = ''
                } else if (!res.data[0].contacts_phone) {
                    name = res.data[0].organize_name + '/' + res.data[0].organize_phone
                } else if (!res.data[0].organize_phone) {
                    name = res.data[0].contacts_name + '/' + res.data[0].contacts_phone
                } else {
                    name = res.data[0].contacts_name + '/' + res.data[0].contacts_phone + ';' + '<br/>' + res.data[0].organize_name + '/' + res.data[0].organize_phone
                }
                this.details.forEach(el => {
                    if (el.id === 'sms') {
                        el.val = name
                    }
                })
            }
        },

        async getDevInfo(proId, deviceIdent) {//设备信息，就是设备名称list
            let params = {
                projectId: proId,
                deviceIdent: deviceIdent
            }
            const res = await getDevInfoByProId(params)
            if (res.code === 200) {
                this.details.forEach(el => {
                    if (el.id === 'sn') {
                        el.val = res.data[0].sn
                    }
                    if (el.id === 'device_type_name') {
                        el.val = res.data[0].device_type_name
                    }
                })
            }
        },

        changeCurrentPage(val) {
            this.page = val
            this.getPoliceHisList()
        },

        changeSize(val) {
            this.pageSize = val
            this.getPoliceHisList()
        },

        handleClose(done) {
            done();
        },

        handleDispose(row) {
            this.pupUp = true
            this.eventHistoryIdent = row.eventHistoryIdent
            this.process = row.process
        },

        async handleConfirm() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    let params = {
                        eventHistoryIdent: this.eventHistoryIdent,
                        process: this.ruleForm.alarmRadio,
                        processDesc: this.ruleForm.textarea
                    }
                    getPoliceProcess(params).then(res => {
                        if (res.code == 200) {
                            this.pupUp = false
                            this.$refs['ruleForm'].resetFields();
                            this.getPoliceHisList()
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleCancel() {
            this.$refs['ruleForm'].resetFields();
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.proIds = []
            val.map(el => {
                this.proIds.push(el.deviceIdent)
            })
        },


        handleChangeProjectId(val) {//项目改变触发
            this.selectVal.deviceId = ''
            this.page = 1
            this.getDevInfoByProId()//根据项目拿到设备list
            this.getPoliceHisList()//历史数据
        },

        async getDevInfoByProId() {//设备名称
            let params = {
                projectId: this.selectVal.allProject,
            }
            const res = await getDevInfoByProId(params)
            if (res.code === 200) {
                this.deviceList = res.data
            } else {
                this.deviceList = []
            }
        },

        //设备改变
        handleChangeDevice(val) {//设备改变触发
            this.page = 1
            this.getPoliceHisList()//历史数据
        },

        //时间改变以后 调用请求数据接口
        handleOnChange() {
            this.page = 1
            this.getPoliceHisList()
        },

        async getDevAttrName() {
            const res = await getDevAttrName(this.selectVal.deviceId)
            if (res.code == 200) {
                this.attrNameList = res.data
            }
        },

        // handleChangeAttrName(val) {//属性改变触发
        //     this.selectVal.attrIdent = val
        //     // this.getDevHisData()
        // },


        handleReset() {//重置按钮
            this.page = 1
            for (let k in this.selectVal) {
                this.selectVal[k] = null
            }
            this.selectVal.alarmDate = [moment().subtract(7, "days").format('x'), moment().format('x')]
            this.deviceList = []
            this.getPoliceHisList()//历史数据
        },

        handleSearch() {//查询按钮
            this.page = 1
            this.getPoliceHisList()//历史数据
        },
        







        handleExportData() {
            this.processExportedTableData(this.tableColumn, this.tableData, '报警历史' + moment().format('_YYYYMMDDHHmmss'))
            return;
        },

        processExportedTableData(headerlist, tablelist, text) {
            let data = []
            let theade = []
            headerlist.forEach(item => {
                if (item.prop === 'handle') return;
                theade.push(item.label)
            })
            data.push(theade)
            tablelist.forEach(item => {
                let tbody = []
                headerlist.forEach(el => {
                    if (el.prop === 'handle') return;
                    if (el.prop === 'process') {
                        let text = ''
                        switch (item[el.prop]) {
                            case 0:
                                text = '处理'
                                break;
                            case 1:
                                text = '已处理'
                                break;
                            case 2:
                                text = '误报'
                                break;
                        }
                        tbody.push(text)
                    } else {
                        tbody.push(item[el.prop])
                    }
                })
                data.push(tbody)
            })
            // return
            /* generate worksheet */
            const ws = XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
            /* generate workbook and add the worksheet */
            const wb = XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            /* save to file */
            XLSX.writeFile(wb, text + '.xlsx');

            // return {data,fileName}
        },



        handleSort(prop, order) {//排序
            this.sortBy = prop
            if (order === 'ascending') {//升序
                this.order = "asc"
            } else if (order === 'descending') {//降序
                this.order = 'desc'
            } else {
                this.order = ""
                this.sortBy = ''
            }
            this.getPoliceList()//发送请求
        },



        findall(a, x) {//查找数组中某个值出现的所有下标
            let results = [],
                len = a.length,
                pos = 0;
            while (pos < len) {
                pos = a.indexOf(x, pos);
                if (pos === -1) {//未找到就退出循环完成搜索
                    break;
                }
                results.push(pos);//找到就存储索引
                pos += 1;//并从下个位置开始搜索
            }
            return results;
        },

        //导出
        async exportExl() {
            let params = {
                fileName: "报警历史数据",
                deviceIdent: this.proIds,
                devTitles: this.tableColumn
            }
            const res = await getBjHisExport(params)
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
            const fileName = '报警历史数据'
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
        },

        //导出
        exportExl_11111() {
            let a = document.createElement('a')
            exportExl({ proTitles: this.tableColumn, proIds: [], fileName: '历史数据' }).then(res => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                const fileName = ''
                const elink = document.createElement('a')
                elink.download = fileName
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
            })
        }
    },
}
